import { create } from "zustand";
export const usePlatformStateStore = create((set) => ({
    info: null,
    set: (info) => set({ info }),
    clear: () => set({ info: null }),
}));
